class TimezoneCountryService {
    private timezoneCountryCache: any[] | null = null;

    // Method to get all timezone countries
    async getTimezoneCountry(): Promise<any[]> {
      if (this.timezoneCountryCache) {
        return this.timezoneCountryCache;
      }

      try {
        const publicUrl = process.env.PUBLIC_URL || "";
        const jsonPath = `${publicUrl}/data/timezone-country.json`;
        const response = await fetch(jsonPath);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch timezone country data: ${response.status} ${response.statusText}`);
        }
        
        const data: any[] = await response.json();
        this.timezoneCountryCache = data;
        return this.timezoneCountryCache || [];
      } catch (error) {
        console.error("Error fetching timezone country data:", error);
        // Return empty array to prevent breaking the app
        return [];
      }
    }
  }
  
  export default new TimezoneCountryService();